import { useTranslation } from 'react-i18next';
import { BatterSessionTimelineChartDataDto, PlayerStatChartConfigDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import HeatLineChart from 'components/HeatLineChart/HeatLineChart';

const BatterSessionTimelineChart = ({
  chartData,
  isLoading,
  extraChartData,
}: ChartProps<BatterSessionTimelineChartDataDto, PlayerStatChartConfigDto>) => {
  const { t } = useTranslation();

  return (
    <HeatLineChart
      label={t(extraChartData.playerStat)}
      heatLinePoints={chartData?.movingAverage ?? []}
      baseLinePoints={chartData?.rollingAverage ?? []}
    />
  );
};

export default BatterSessionTimelineChart;
